import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggerService } from '../services/logger.service';
import { VersionCheckService } from '../services/version-check.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const logger = this.injector.get(LoggerService);
    
    let message = error?.message ? error.message : (error?.toString?.() || 'Unknown error');
    
    // Check if error is due to missing chunks/lazy-loaded modules after deployment
    const isChunkFailed =
      error?.name === 'ChunkLoadError' ||
      message.includes('Loading chunk') ||
      message.includes('Failed to fetch dynamically imported module') ||
      message.includes('Importing a module script failed') ||
      message.includes('error loading dynamically imported module');

    if (isChunkFailed) {
      console.warn('Chunk load error detected (new version deployed):', message);
      try {
        const versionCheck = this.injector.get(VersionCheckService);
        versionCheck.triggerUpdateModal(
          'We have updated the website with new improvements. We are sorry, please reload the page to continue.'
        );
      } catch {
        if (typeof window !== 'undefined') {
          window.location.reload();
        }
      }
      return;
    }

    // Attempt to extract line and file from stack trace if available
    let file = undefined;
    let line = undefined;
    
    if (error.stack) {
      const stackLines = error.stack.split('\n');
      if (stackLines.length > 1) {
        // Simple extraction logic for demonstration
        const match = stackLines[1].match(/(http.*):(\d+):(\d+)/);
        if (match) {
          file = match[1];
          line = parseInt(match[2], 10);
        }
      }
    }
    logger.error(message, {
      file,
      line
    });

    // Still log to console for debugging
    console.error('Global Error Handler caught:', error);
  }
}
